module.exports = __webpack_public_path__ + "static/media/pt.e4e7ebe5.svg";